// export {ModuleFederationPlugin} from '@module-federation/rspack'
export {ModuleFederationPlugin} from '@empjs/module-federation-rspack'
